import SmoothScrollbars from '@rio-cloud/rio-uikit/components/smoothScrollbars/SmoothScrollbars';
import Fade from '@rio-cloud/rio-uikit/Fade';
import { useCallback, useEffect, useRef } from 'react';
import { useNavigate } from 'react-router';
import { DEFAULT_ROUTE, VEHICLE_ROUTE } from '../../common/constants';
import { PageNavigationBar } from '../../components/PageNavigationBar/PageNavigationBar';
import { useAppDispatch, useAppSelector } from '../../configuration/setup/hooks';
import { VehicleOptions } from '../../containers/VehicleOptions/VehicleOptions';
import { selectPageDisplayed } from '../../store/app/appSelectors';
import { updatePage } from '../../store/app/appSlice';

export const VehicleOptionsPage = () => {
    const navigate = useNavigate();
    const dispatch = useAppDispatch();
    const hasInitialized = useRef(false);

    const pageDisplayed = useAppSelector(selectPageDisplayed);
    const showContent = pageDisplayed === VEHICLE_ROUTE;

    // Sync Redux pageDisplayed state only on initial mount when navigating directly to this route (e.g. via URL)
    useEffect(() => {
        if (!hasInitialized.current && pageDisplayed !== VEHICLE_ROUTE) {
            dispatch(updatePage(VEHICLE_ROUTE));
        }
        hasInitialized.current = true;
    }, [dispatch, pageDisplayed]);

    const handleExitNav = useCallback(() => {
        navigate(DEFAULT_ROUTE, { replace: false });
    }, [navigate]);

    const handleClickGoBackNav = useCallback(() => {
        dispatch(updatePage(DEFAULT_ROUTE));
    }, [dispatch]);

    return (
        <Fade initial animationStyle={Fade.PAGE_BACK} show={showContent} onExitComplete={handleExitNav}>
            <div className='display-flex flex-column height-100vh' data-testid='route-summary-page'>
                <div data-testid='summary-back-button'>
                    <PageNavigationBar
                        title='intl-msg:smartRoute.generic.vehicleSettings'
                        navBack={handleClickGoBackNav}
                    />
                </div>
                <SmoothScrollbars>
                    <div
                        className='display-flex flex-column padding-x-15 padding-top-15'
                        data-testid='vehicle-options-page'
                    >
                        <VehicleOptions />
                    </div>
                </SmoothScrollbars>
            </div>
        </Fade>
    );
};
